
const maxRetries = 30
const send = (url: string, opts: Options, request: XMLHttpRequest, errorCount: number): void => {
  if (errorCount >= maxRetries) {
    request.abort();
    request = null
    return
  }
  let limit = errorCount
    ? Math.pow(2, errorCount - 1) * opts.startLimit
    : 0;
  limit = limit < opts.maxLimit ? limit : opts.maxLimit
  const pause = Math.random() * limit;
  setTimeout(function () {
    request.open('POST', url, true)
    for (const k in opts.headers) {
      if (Object.prototype.hasOwnProperty.call(opts.headers, k)) {
        request.setRequestHeader(k, opts.headers[k])
      }
    }
    request.send()
  }, pause)
}

type Options = {
  startLimit?: number;
  maxLimit?: number;
  enableWithCredentials?: boolean;
  headers?: any
}

const xhr = (url: string, opts: Options, callback: (v: string) => void): XMLHttpRequest => {
  opts = {startLimit: 100, maxLimit: 3 * 1000, enableWithCredentials: false, ...opts};
  let errorCount = 0;
  const request = new XMLHttpRequest();
  if (opts.enableWithCredentials) request.withCredentials = true;
  const retry = (): void => send(url, opts, request, ++errorCount);
  request.addEventListener('error', retry);
  request.addEventListener('timeout', retry);
  request.addEventListener('load', () => {
    if (request.status >= 200 && request.status < 300) {
      return callback(request.responseText)
    }
    retry()
  })

  send(url, opts, request, errorCount)
  return request;
}

const http = {
  send: xhr,
}
export default http;
